import Card from "../Base/Card";
import {FiChevronDown, FiPlus} from "react-icons/fi";
import BaseFilter from "../Base/BaseFilter";
import BaseDateRangePicker from "../Base/BaseDateRangePicker";
import {Table} from "../Base/BaseTable";
import NoTransactionImage from "../../assets/images/no-transactions.png";
import React, {useEffect, useMemo, useState} from "react";
import {HiDotsVertical} from "react-icons/hi";
import ClickAwayListener from "../ClickAwayListener";
import { getAllPFA } from "../../redux/selfService/selfServiceSlice";
import { getReferralAndRewards, getStates } from "../../redux/utils/utilsSlice";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

interface PropsI {
    isTransfer?: boolean;
    onClickMainButton: () => void;
}

const RSATable = ({ isTransfer, onClickMainButton }: PropsI)=>{
    const dispatch = useAppDispatch();
    const [filterValue, setFilterValue] = useState('');
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>()

    const { paymentitems } = useAppSelector((state) => state?.utils);
   
    const setDateRangeHandler = (dates: Date[]) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    };

    //

    // const PageNumber = pageIndex + 1; // Calculate PageNumber from the table's pageIndex
    // const PageSize = pageSize; // Get PageSize directly from the table's pageSize
  

    const tableData = useMemo(() => paymentitems?.result || [], []);

    useEffect(()=>{
        dispatch(getReferralAndRewards({PageNumber:1, PageSize:100}))
        .then((res)=>{
            console.log('getReferralAndRewards',res.payload);
            if(res?.type==="SelfServices/getmytransfer/fulfilled" ){
               
            }
        });
       // dispatch(getStates());
    },[])
    // PageNumber, PageSize

    const columns = useMemo(()=>[
        // {
        //     Header: 'RSA ID',
        //     accessor: 'id'
        // },
        {
            Header: 'Sur Name',
            accessor: 'surname'
        },
        {
            Header: 'First Name',
            accessor: 'firstname'
        },
        // {
        //     Header: 'Other Names',
        //     accessor: 'othernames'
        // },
        {
            Header: 'Old PFA',
            accessor: 'oldPfa'
        },
        {
            Header: 'PIN',
            accessor: 'pin'
        },
        {
            Header: 'Mobile Phone',
            accessor: 'mobilePhone',
        },
        {
            Header: 'Email Address',
            accessor: 'emailAddress',
        },
        {
            Header: 'date of Birth',
            accessor: 'dob',
        },

        

        // {
        //     Header: 'NIN',
        //     accessor: 'nin',
        // },

        
        {
            Header: 'Date Created',
            accessor: 'dateCreated',
        },
        {
            Header: 'RSA Status',
            accessor: 'rsastatus',
            // @ts-ignore
            // Cell: ({row: { values }})=>{
            //     return (
            //         <span className="btn text-primary rounded-full bg-grayscaleLine whitespace-pre py-1 px-2">
            //             In Progress
            //         </span>
            //     )
            // }
        },
        // {
        //     Header: 'Action',
        //     accessor: '',
        //     // @ts-ignore
        //     Cell: ({row: { values }})=>{
        //         return (
        //             <>
        //                 {/* <button className="btn btn-text text-grayscaleOffBlack font-bold text-2xl">
        //                     <HiDotsVertical />
        //                 </button> */}
        //                 {/*
        //                 <ClickAwayListener onClickAway={close}>
        //                     <div className="dropdown">

        //                     </div>
        //                 </ClickAwayListener>*/}
        //             </>

        //         )
        //     }
        // },
    ], [])

    // const tableData = useMemo(()=>[
    //     {
    //         id: "00123",
    //         firstName: "Oluwasegun",
    //         lastName: "Segun",
    //         pin: "PEN110008156635",
    //         accountType: "Retirement Savings",
    //         receiveRFA: "Stanbic IBTC Pension Managers Limited",
    //         dateCreated: "04/01/2023 02:25:21",
    //         amount: 53000,
    //     }
    // ], [])




    return (
        <div className="transaction">
            <Card className="transaction-card">
                <div className="h1 text-grayscaleBody border-b pb-4">
                    { !isTransfer ? 'Registered RSA' : 'Refer and Reward' }
                </div>
                <div className="flex justify-end mt-10">
                    <button className="btn btn-primary btn-b" onClick={onClickMainButton}>
                        <FiPlus className="text-xl mr-4" />
                        { !isTransfer ? 'New RSA' : 'New Referral' }
                    </button>
                </div>
                <div className="table-filter-group">
                    <div className="table-filter">
                        <BaseFilter
                            value={filterValue}
                            onChange={val=>setFilterValue(val)}
                        />
                        {/* <BaseDateRangePicker
                            className="mt-4 sm:mt-0 max-w-full  sm:max-w-[328px] sm:ml-4"
                            onChange={(date)=>setDateRangeHandler(date)}
                        /> */}
                        {/*
                        <div>
                            <button className="btn btn-outline btn-b">
                                Search
                            </button>
                        </div>
                    */}
                    </div>
                    {/* <div className="table-sort">
                        <button className="btn btn-outline btn-b">
                            Sort
                            <FiChevronDown className="ml-2 " />
                        </button>
                    </div> */}
                </div>
                <div className="mt-10">
                    {/*@ts-ignore*/}
                    <Table filterValue={filterValue} columns={columns} data={ (paymentitems?.result??[])} />
                </div>
            </Card>
        </div>
    )
}

export default RSATable;